import React, {useContext, useEffect} from "react";
import Banner, {bannerStyle} from "@components/Banner";
import css from "./GiustificazioneDiMassa.module.css";
import WFCss from "../calendarioPresenze_WF.module.css";
import filtroCss from "../monitorWF/filtroRichiesteWF.module.css";
import Select from "@components/wrapperComponents/Select";
import {useForm} from "react-hook-form";
import {GiustificazioneDiMassaTask} from "@commons/services/presenze_calcolo/sub_calcolo/GiustificazioneDiMassaTask";
import RadioInput from "@components/RadioInput";
import {ComboBoxGiustificativo} from "@components/comboBox/ComboBoxGiustificativo";
import {GiustificativoFilter} from "../GiustificativoFilter";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import CheckboxEx from "@components/wrapperComponents/CheckboxEx";
import {IconCalculator, IconX} from "@tabler/icons-react";
import classNames from "classnames";
import * as Validation from "@utilities/validationRules";
import {NumberFormatValues} from "react-number-format";
import {InputCleave2} from "@components/wrapperComponents/InputCleave2";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeContext} from "@commons/hooks/usePresenze";
import {StatoGM} from "../GestionePLUS/calendario.GestionePLUS";
import {Calcolo} from "@commons/services/presenze_calcolo/Calcolo";

interface PanelGMProps {
    lavoratore: Pick<LavoratorePresenzeRecord, 'cognome' | 'nome' | 'days'>,
    setStatoGM: React.Dispatch<React.SetStateAction<StatoGM>>,
    setDaysForGM: React.Dispatch<React.SetStateAction<PresenzeGiornataPlusRecord[]>>,
    applicaGM: (payload: GiustificazioneDiMassaTask) => void;
    paginaPlus?: boolean,
}

interface GMForm extends GiustificazioneDiMassaTask {
    tipoGiu: 'O' | 'Q' | 'I',
}

const PanelGM: React.FC<PanelGMProps> = ({
                                             lavoratore,
                                             setStatoGM,
                                             setDaysForGM,
                                             applicaGM,
                                             paginaPlus = true,
                                         }) => {
    const {listaGiustificativi: giustificativi, periodo} = useContext(PresenzeContext);

    const hook = useForm<GMForm>({
        defaultValues: {tipoGiu: 'O', ...GiustificazioneDiMassaTask.factory({anno: periodo.anno, mese: periodo.mese, selezioneAutomatica: true})},
        mode: 'onChange',
        reValidateMode: 'onChange'
    });

    const {control, register, setValue, handleSubmit, watch, formState: {errors}, trigger} = hook;

    const operazione = watch('tipoOperazione');
    const tipoGiustificativo = watch('tipoGiu');
    const controlloSuOre = watch('controllo');

    const isOrario = tipoGiustificativo === 'O';
    const isQuantita = tipoGiustificativo === 'Q';

    const isInserimento = operazione === 'INSERIMENTO'
    const isModifica = operazione === 'MODIFICA'

    const hasGiorniSTD = () => {
        let _hasGiorniSTD = false;
        Calcolo.forEachDay(lavoratore.days, periodo.mese, (day) => {
            if (day.tipoRilevazione === 'MANUALE') {
                _hasGiorniSTD = true;
            }
        });
        return _hasGiorniSTD;
    };

    const hasGiorniPLUS = () => {
        let _hasGiorniPLUS = false;
        Calcolo.forEachDay(lavoratore.days, periodo.mese, (day) => {
            if (day.tipoRilevazione !== 'MANUALE') {
                _hasGiorniPLUS = true;
            }
        });
        return _hasGiorniPLUS;
    };

    useEffect(() => {
        setValue('codGiu', '')
        setValue('codGiuDaSostituire', '')
    }, [operazione, setValue, tipoGiustificativo]);

    const labelQuantitaGiu = isOrario ? "Ore" : (isQuantita ? 'Quantità' : 'Importo');

    const onHandleSubmit = (payload: GMForm) => {
        applicaGM(payload);
        setStatoGM('IN_PAUSA');
    }

    return <form className="border-2 border-[#218a9e] p-1.5 text-gray-700 mb-0.5 select-none" onSubmit={handleSubmit(onHandleSubmit)}>
        <div className={`${WFCss.intestazioneFooter} text-white bg-[#235F6A]`}>
            {lavoratore.cognome}&nbsp;{lavoratore.nome}&nbsp;-&nbsp;Giustificazione di massa delle giornate evidenziate
        </div>

        {paginaPlus && hasGiorniSTD() && <Banner style={bannerStyle.primary} className={css.bannerAlertGM}>
            <p>
                N.B. Sono presenti giornate gestite in modalit&agrave; manuale!<br/>
                Verrano giustificate <span className="font-bold">solo le giornate gestiste CON la rilevazione automatica delle timbrature!</span>
            </p>
        </Banner>}
        {!paginaPlus && hasGiorniPLUS() && <Banner style={bannerStyle.primary} className={css.bannerAlertGM}>
            <p>
                N.B. Sono presenti giornate gestite CON la rilevazione automatica delle timbrature!<br/>
                Verrano giustificate <span className="font-bold">solo le giornate gestiste in modalit&agrave; manuale!</span>
            </p>
        </Banner>}

        <div className={css.rigaFormGM}>
            <Select label={<div className={css.labelsGM}>Operazione</div>} id="tipoOperazione" name="tipoOperazione"
                    divClass="w-1/3" register={register}>
                <>
                    {GiustificazioneDiMassaTask.elencoOperazioni
                        .map((item, index) => (
                            <option key={item.id} value={item.id} className={filtroCss.selectOptFilter}>
                                {item.descrizione}
                            </option>))}
                </>
            </Select>

            <div className="w-1/3">
                <label className="mb-1 block font-medium text-elemPresenze">Tipo giustificativo</label>
                <RadioInput label="Orario" name="tipoGiu" id="orario" value="O" className="!mb-0.5"
                            register={register} registerOptions={Validation.required}/>
                <RadioInput label="Quantità" name="tipoGiu" id="quantita" value="Q" className="!mb-0.5"
                            register={register} registerOptions={Validation.required}/>
                <RadioInput label="Importo" name="tipoGiu" id="importo" value="I" className="!mb-0.5"
                            register={register} registerOptions={Validation.required}/>
            </div>

            <div className="w-1/3">
                {!isModifica && <ComboBoxGiustificativo<GMForm> label="Giustificativo" labelClassName="text-elemPresenze" name="codGiu" defaultValue=''
                                                                data={giustificativi
                                                                    .filter(giu => GiustificativoFilter.filterTipoGiu(giu, tipoGiustificativo))
                                                                    .filter(giu => GiustificativoFilter.filterProfiloGiu(giu))
                                                                }
                                                                onChange={(v) => v ? setValue('codGiu', v.codGiu!) : ''}
                                                                disabled={!tipoGiustificativo || !giustificativi}
                                                                rules={{required: true}} control={control}/>
                }

                {isModifica &&
                    <ComboBoxGiustificativo<GMForm> label='Giustificativo precedente' labelClassName="text-elemPresenze" name="codGiuDaSostituire" defaultValue=''
                                                    data={giustificativi
                                                        .filter(giu => GiustificativoFilter.filterTipoGiu(giu, tipoGiustificativo))
                                                        .filter(giu => GiustificativoFilter.filterProfiloGiu(giu))
                                                    }
                                                    onChange={(v) => v ? setValue('codGiuDaSostituire', v.codGiu!) : ''}
                                                    disabled={!tipoGiustificativo || !giustificativi}
                                                    rules={{required: true}} control={control}/>
                }

                {isModifica && <ComboBoxGiustificativo<GMForm> label='Nuovo giustificativo' labelClassName="text-elemPresenze mt-1" name="codGiu" defaultValue=''
                                                               data={giustificativi
                                                                   .filter(giu => GiustificativoFilter.filterTipoGiu(giu, tipoGiustificativo))
                                                                   .filter(giu => GiustificativoFilter.filterProfiloGiu(giu))
                                                               }
                                                               onChange={(v) => v ? setValue('codGiu', v.codGiu!) : ''}
                                                               disabled={!tipoGiustificativo || !giustificativi}
                                                               rules={{required: true}} control={control}/>
                }
            </div>
        </div>

        <div className={css.rigaFormGM}>
            <div className="w-1/3">
                <Select label={<div className={css.labelsGM}>Controlle su ore</div>} id="controllo" name="controllo"
                        disabled={!isInserimento || !isOrario} register={register}>
                    <>
                        {GiustificazioneDiMassaTask.elencoControllo
                            .map((item, index) => (
                                <option key={item.id} value={item.id} className={filtroCss.selectOptFilter}>
                                    {item.descrizione}
                                </option>))}
                    </>
                </Select>
            </div>

            <div className="w-1/3">
                <InputCleave2<GMForm> label={labelQuantitaGiu} placeholder={isOrario ? 'hh.cc' : ''} labelClassName={css.labelsGM}
                                      name="ore" valueAsNumber={true}
                                      options={{
                                          allowNegative: false, allowedDecimalSeparators: [','], fixedDecimalScale: false, decimalScale: isOrario ? 2 : 3,
                                          isAllowed: ({floatValue}: NumberFormatValues) => {
                                              if (isOrario)
                                                  return floatValue ? floatValue <= 24 : true;
                                              else return true;
                                          }
                                      }}
                                      disabled={(isOrario && controlloSuOre !== 'NESSUN_CONTROLLO') || !isInserimento}
                                      onChange={(v) => {
                                          setValue('ore', v)
                                      }}
                                      control={control} errorPortalId="errorQuantita"/>
            </div>

            <div className="w-1/3">
                <Select label={<div className={css.labelsGM}>Se giustificativo presente</div>}
                        id="azioneXGiuPresente" name="azioneXGiuPresente"
                        onChange={(e) => {
                            // @ts-ignore
                            setValue('azioneXGiuPresente', e.target.value)
                        }}
                        disabled={!isInserimento}
                        register={register}>
                    <>
                        {GiustificazioneDiMassaTask.massaControlloGiustificativo
                            .map((item, index) => (
                                <option key={item.id} value={item.id} className={filtroCss.selectOptFilter}>
                                    {item.descrizione}
                                </option>))}
                    </>
                </Select>
            </div>
        </div>

        <div className={css.rigaFormGM}>
            <div className="w-1/3 space-y-1">
                <label className={classNames(css.labelsGM, 'font-medium')}>Opzioni di giustificazione</label>
                <CheckboxEx label="Calcolo presenze (anomalie)" name="calcolaPresenze" id="calcolaPresenze" control={control} disabled={true}/>
                <CheckboxEx label="Elabora giorni bloccati" name="elaboraGiorniBloccati" id="elaboraGiorniBloccati" control={control}/>
                <CheckboxEx label="Salva presenze al termine" name="salvaPresenze" id="salvaPresenze" control={control} disabled={true}/>
            </div>
        </div>

        <div className={classNames(css.rigaFormGM, '!gap-x-3')}>
            <button className="btnPrimary ml-auto !px-1 max-[715px]:text-xs">
                <IconCalculator className="h-4 w-4 sm:h-5 sm:w-5"/>Esegui giustificazione di massa
            </button>
            <button className="btnPrimary !px-1 max-[715px]:text-xs" type="button" onClick={() => {
                // Pulisco array di giorni da giustificare
                setDaysForGM([]);
                // chiudo la GM
                setStatoGM('IN_PAUSA')
            }}>
                <IconX className="h-4 w-4 sm:h-5 sm:w-5"/>Annulla GM
            </button>
        </div>
    </form>
}

export default PanelGM;